'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var styled = require('styled-components');
require('../../../../enums/accordion.js');
require('../../../../enums/alert.js');
require('../../../../enums/avatar.js');
require('../../../../enums/breakpoints.js');
var button = require('../../../../enums/button.js');
require('../../../../enums/code-editor.js');
require('../../../../enums/colors.js');
require('../../../../enums/combobox.js');
require('../../../../enums/date.js');
require('../../../../enums/drag-and-drop.js');
require('../../../../enums/dialog.js');
require('../../../../enums/divider.js');
require('../../../../enums/dropdown.js');
require('../../../../enums/fieldset.js');
require('../../../../enums/font-icon.js');
require('../../../../enums/fonts.js');
require('../../../../enums/headings.js');
require('../../../../enums/input.js');
require('../../../../enums/keys.js');
require('../../../../enums/list.js');
require('../../../../enums/listbox.js');
require('../../../../enums/loader.js');
require('../../../../enums/margin.js');
require('../../../../enums/option.js');
require('../../../../enums/pill.js');
require('../../../../enums/placements.js');
var popout$1 = require('../../../../enums/popout.js');
require('../../../../enums/privacy.js');
require('../../../../enums/radio-group.js');
require('../../../../enums/status.js');
require('../../../../enums/switch.js');
require('../../../../enums/table.js');
require('../../../../enums/tooltip.js');
require('../../../../enums/transitions.js');
require('../../../../enums/widths.js');
require('../../../../styles/styled-components/alert.js');
require('../../../../styles/styled-components/animations.js');
var boxShadow = require('../../../../styles/styled-components/box-shadow.js');
require('../../../../styles/styled-components/button.js');
require('../../../../themes/alert.js');
var borders = require('../../../../themes/borders.js');
require('../../../../themes/button.js');
require('../../../../themes/checkbox.js');
require('../../../../themes/divider.js');
require('../../../../themes/dropdown.js');
require('../../../../themes/fieldset.js');
var fonts = require('../../../../themes/fonts.js');
require('../../../../themes/input.js');
require('../../../../themes/list.js');
require('../../../../themes/listbox.js');
require('../../../../themes/loader.js');
require('../../../../themes/option.js');
require('../../../../themes/popout.js');
require('../../../../themes/switch.js');
var themes = require('../../../../themes/themes.js');
require('../../../../themes/tooltip.js');
require('../../../../styles/styled-components/font-face.js');
require('../../../../styles/styled-components/global.js');
require('../../../../styles/styled-components/input.js');
require('../../../../styles/styled-components/list.js');
require('../../../../styles/styled-components/listitem.js');
require('../../../../styles/styled-components/media-queries.js');
require('../../../../styles/styled-components/reset.js');
require('../../../../styles/styled-components/outline.js');
var popout = require('../../../../styles/styled-components/popout.js');
var screenReader = require('../../../../styles/styled-components/screen-reader.js');
require('../../../../styles/styled-components/switch.js');
require('../../../../styles/styled-components/tooltip.js');
var basePopout = require('../base-popout/base-popout.js');

function _interopDefaultCompat (e) { return e && typeof e === 'object' && 'default' in e ? e : { default: e }; }

var React__default = /*#__PURE__*/_interopDefaultCompat(React);
var styled__default = /*#__PURE__*/_interopDefaultCompat(styled);

function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
const BaseStandardPopout = (props)=>{
    const { closeButtonProps , look , ...otherProps } = props;
    const getCloseButtonLook = ()=>{
        switch(look){
            case popout$1.PopoutLooks.Primary:
                {
                    return button.ButtonLooks.White;
                }
            default:
                {
                    return button.ButtonLooks.Default;
                }
        }
    };
    return /*#__PURE__*/ React__default.default.createElement(basePopout.BasePopout, _extends({}, otherProps, {
        closeButtonProps: {
            ...closeButtonProps,
            look: getCloseButtonLook()
        },
        variant: popout$1.PopoutVariants.Standard
    }));
};
const getCloseButtonPosition = ({ title  })=>{
    if (!title) {
        return styled.css`
      position: absolute;
      right: 10px;
      top: 10px;
    `;
    }
    return styled.css``;
};
const getBodyPadding = ({ showCloseButton , title  })=>{
    if (showCloseButton && !title) {
        return styled.css`
      padding: 15px 35px 15px 20px;
    `;
    }
    return styled.css`
    padding: 20px;
  `;
};
const getHeaderStyles = ({ title  })=>{
    if (title) {
        return styled.css`
      border-bottom-color: 'transparent';
      border-bottom-style: solid;
      border-bottom-width: 1px;
      display: flex;
      padding: 15px;
    `;
    }
    return styled.css``;
};
const Popout = styled__default.default(BaseStandardPopout)`
  ${({ look  })=>popout.getPopoutTheme({
        look
    })}

  .bf-popout__arrow {
    height: 8px;
    width: 15px;
  }

  .bf-popout__body {
    ${({ showCloseButton , title  })=>getBodyPadding({
        showCloseButton,
        title
    })}
    overflow: auto;
  }

  .bf-popout__footer {
    border-top-color: 'transparent';
    border-top-style: solid;
    border-top-width: 1px;
    display: flex;
    justify-content: flex-end;
    padding: 20px;
  }

  .bf-popout__header {
    ${({ title  })=>getHeaderStyles({
        title
    })}
    position: relative;
  }

  .bf-popout__heading {
    font-family: ${fonts.fontFamilyBook};
    font-size: 18px;
    font-weight: 400;
    line-height: 24px;
    overflow-wrap: break-word;
  }

  .bf-popout__close {
    ${({ title  })=>getCloseButtonPosition({
        title
    })}
    font-size: 14px;
    height: 20px;
    margin-left: auto;
    padding: 10px;
    width: 20px;
  }

  .bf-popout__close--hidden {
    ${screenReader.screenReaderOnly}
  }

  .bf-button__close-icon {
    font-size: 13px;
  }

  .bf-popout__dialog {
    z-index: 1;
  }

  .bf-popout__dialog-inner {
    ${boxShadow.boxShadowDialogs}
    border-radius: ${borders.borderRadiusMedium}px;
    font-family: ${fonts.fontFamilyBook};
    font-size: 14px;
    line-height: 22px;
    overflow: hidden;
  }

  .bf-popout__trigger {
    display: inline-block;
  }
`;
/**
 * The difference between tooltips and popouts: Tooltips are meant to be tabbed over, contain only text content (no focusable elements),
 * and use `role="tooltip"`; Popouts are meant to be tabbed in to, can contain focusable elements and text content, and use `role="dialog"`.
 * 
 * Required props include `children`, `content`, `id`, `labels`, `open`, and `setOpen`.
 * All of these props are required for accessibility compliance.
 * 
 * The popout dialog will automatically try and position itself so that it doesn't show off screen 
 * (via the `preventCutoff` prop, which defaults to `true`).
 * 
 * To turn off focus lock, set the `focusLock` prop to `false`. This will turn off users cycling through
 * tabbable elements within the dialog via the `Tab` key. Turning this off is only recommended if your
 * dialog only contains non-tabbable content, such as headings and paragraphs.
 * 
 * You can show a `<CircleLoader>` by setting the `loading` prop to `true` and making sure to pass in
 * `labels.loaderLabel` string.
 * 
 * A popout is a `role="dialog"` with positioning powers. See https://www.w3.org/WAI/ARIA/apg/example-index/dialog-modal/dialog
 * for examples of dialogs.
 * 
 * @example
 * const [open, setOpen] = useState(false);

  const id = 'standard-popout';

  return (
    <StandardPopout
      labels={{
        closeButtonLabel: 'Close',
        loaderLabel: 'Loading'
      }}
      content={<p>Content</p>}
      id={id}
      open={open}
      setOpen={setOpen}
    >
      <StandardButton
        aria-controls={id}
        aria-expanded={open}
        aria-haspopup="dialog"
        onClick={(): void => setOpen(!open)}
      >
        Open popout
      </StandardButton>
    </StandardPopout>
  );
 * @param props StandardPopoutProps
 * @returns FunctionComponent<StandardPopoutProps>
 */ const StandardPopout = (props)=>{
    const { look =popout$1.PopoutLooks.Default , showCloseButton =true , ...otherProps } = props;
    const themeContext = React.useContext(styled.ThemeContext);
    return /*#__PURE__*/ React__default.default.createElement(styled.ThemeProvider, {
        theme: themeContext || themes.lightTheme
    }, /*#__PURE__*/ React__default.default.createElement(Popout, _extends({}, otherProps, {
        look: look,
        showCloseButton: showCloseButton
    })));
};

exports.StandardPopout = StandardPopout;
//# sourceMappingURL=standard-popout.js.map
